/**
@ngdoc directive
@name moreLess

@param {boolean} dynamic please set to "true" if you need the content to be compiled ie. you have some {{ }} inside the content
@param {boolean} preformatted set to "true" for textarea content
*/

(function() {
    'use strict';

var idMoreLess = 0; // used to create unique id attribute

var moreLess = function($sce, $filter, $timeout, $compile, $templateCache) {
    return {
        restrict: 'EA',
        scope:true,
        bindToController: {
            isOpen:"=?",
            maxHeight:"@",
            dynamic:"@",
            preformatted:'@'
        },
        controllerAs: 'moreLessCtrl',
        controller: function(){
        },
        transclude: true,
        replace: true,
        template: $templateCache.get('components/moreLess.html'),
        require:'moreLess',
        link: function(scope, element, attrs, ctrl){
            scope.id        = ++idMoreLess;
            ctrl.maxHeight  = ctrl.maxHeight || '250px';
            ctrl.isOpen    = (ctrl.isOpen == "true") ? true : false; // false by default


            function sliceContent(text){
                var ellipsis = (text.length > 255) ? '...' : '';
                return text.slice(0, 255) + ellipsis;
            }

            if(!angular.isDefined(ctrl.dynamic) || ctrl.dynamic!="true"){
                scope.plainText = sliceContent( element.text().trim() );
            } else {
                $timeout(function(){
                    scope.plainText = sliceContent( element.find('[ng-transclude]').text().trim() );
                });
            }

            // accessibility requirement to move to focus to the content on expand
            scope.switchMoreLess = function(e){
                ctrl.isOpen = !ctrl.isOpen;
                $timeout(function(){
                    if(ctrl.isOpen){
                        element.find('.formatted-text:visible').focus();
                    }
                });
            }
        }
    };
}
moreLess.$inject = ['$sce','$filter', '$timeout', '$compile', '$templateCache'];
angular.module('app').directive('moreLess', moreLess);


}());